import { IFileItem } from "../service/public"
import { Commit } from "vuex"
import {
    // getFileListByName,
    getFileListByNameAndTime,
    IGetFileList,
    mkdir,
    IMkdir,
    downloadFileById
} from "@/service/public"
import { Message } from "element-ui"

export interface BreadcrumbItem {
    id: string
    name: string
    path: string
}
export interface PublicStoreState {
    tableRowData: IFileItem
    // tableSelectedDatas: Array<IFileItem>;
    fileListdata: { [key: string]: any }
    breadcrumbData: BreadcrumbItem[]
    powers: number[]
    isShowPermssionDialog: boolean
    isOperate: boolean
    currentDirId: string
    sortNames: string
    sortTrend: number
    leftTreeId: string
    uploadDirId: string
    currentPage: number
    pageSize: number
    dataTotalNum: number
    queryForm: QueryFormData
    newDirName: string
    isShowRightMenu: boolean
    showCacheData: boolean
    copyMoveType: "copy" | "move"
    showCopyMoveBox: boolean
    dialogZipDetailsVisible: boolean
    updateFoldTree: boolean
    updateCompressList: boolean
    updateUnzipList: boolean
    getDataListType: boolean
    disableGetDataList: boolean
    dataList: IFileItem[]
    dataCurrent: number
    iconTypeSize: number
    isUpdateTree: boolean
    isViewPermission: boolean
    isGrantPermission: boolean
}
export interface QueryFormData {
    fileName: string
    createTime: string[]
}
interface PageInfoType {
    id: string | null
    pageNum: number
}
export default {
    namespaced: true,
    state: {
        tableRowData: {},
        // tableSelectedDatas:[],
        fileListdata: {},
        breadcrumbData: [
            
        ],
        powers: [0],
        isShowPermssionDialog: false,
        isOperate:false,
        currentDirId: "0",
        leftTreeId: "0",
        uploadDirId: "0",
        currentPage: 1,
        pageSize: 10,
        sortNames: null,
        sortTrend: null,
        dataTotalNum: 0,
        queryForm: {
            fileName: "",
            createTime: null
        },
        newDirName: "新建文件夹",
        isShowRightMenu: false,
        showCacheData: false, // 页面watch这个属性，手动触发更新，页面先显示store缓存的数据然后再请求数据
        copyMoveType: "move",
        showCopyMoveBox: false,
        dialogZipDetailsVisible: false,
        updateFoldTree: false,
        updateCompressList: false,
        updateUnzipList: false,
        getDataListType:false,
        disableGetDataList:false,
        datalist:[],
        dataCurrent:1,
        iconTypeSize:100,
        isUpdateTree: true,
        isViewPermission: false,
        isGrantPermission: false
    },
    actions: {
    // 切换目录或面包屑时，储存每一级对应的分页数据
        async savePageInfo({ commit }, params: PageInfoType) {
            let pageInfos: PageInfoType[] = []
            if (sessionStorage.getItem("pageInfos")) {
                pageInfos = JSON.parse(sessionStorage.getItem("pageInfos") as string)
            }
            const index = pageInfos.findIndex(info => info.id === params.id)
            if (index >= 0) {
                pageInfos.splice(index, 1)
            }
            pageInfos.push(params)
            sessionStorage.setItem("pageInfos", JSON.stringify(pageInfos))
        },
        async getTableData(
            {
                dispatch,
                commit,
                state
            }: { dispatch: any; commit: Commit; state: PublicStoreState },
            params: any = {}
        ) {
            const currentDirId = state.currentDirId
            // 先触发一次更新列表，然后再去后台查询数据
            commit("UPDATE_TABLE_DATA_CACHE")
            if (params.updataType === "init") {
                if (sessionStorage.getItem("pageInfos")) {
                    const pageInfos = JSON.parse(
                        sessionStorage.getItem("pageInfos") as string
                    )
                    const currentPage = pageInfos.find(info => info.id === currentDirId)
                    if (currentPage) {
                        if (state.currentPage !== currentPage.pageNum) {
                            commit("SET_CURRENT_PAGE", currentPage.pageNum)
                            return
                        }
                    } else {
                        if (state.currentPage !== 1) {
                            commit("SET_CURRENT_PAGE", 1)
                            return
                        }
                    }
                } else {
                    if (state.currentPage !== 1) {
                        commit("SET_CURRENT_PAGE", 1)
                        return
                    }
                }
                commit("SET_CURRENT_SORT_NAMES")
                commit("SET_CURRENT_SORT_TREND")
            }
            const pageNum = state.currentPage
            const reqParams = {
                id: currentDirId,
                current: pageNum,
                size: state.pageSize,
                name: state.queryForm.fileName,
                start:
          state.queryForm.createTime && state.queryForm.createTime.length
              ? state.queryForm.createTime[0]
              : null,
                end:
          state.queryForm.createTime && state.queryForm.createTime.length
              ? state.queryForm.createTime[1]
              : null,
                sortTrend: state.sortTrend,
                sortNames: state.sortNames
            }
            const currentDirData = await getFileListByNameAndTime(reqParams)
            if (currentDirData.code === 0) {
                if (currentDirData.data.length === 0 && currentDirData.total) {
                    commit("SET_CURRENT_PAGE", pageNum - 1)
                    return
                }
                dispatch("savePageInfo", {
                    id: currentDirId,
                    pageNum,
                    pageSize: state.pageSize
                })
                const currentData = currentDirData.data as IFileItem[]
                // 存当前文件夹的文件内容
                commit("SET_FILE_LIST_DATA", {
                    id: currentDirId,
                    data: currentDirData
                })
                // 至少每两次请求会触发一次update，实际
                if(!state.isUpdateTree) {
                    commit('SET_IS_UPDATE_TREE', true)
                } else {
                    commit("UPDATE_FOLD_TREE")
                }
               
                commit("UPDATE_TABLE_DATA_CACHE")
                commit('SET_DISABLE_GET_DATA_LIST',false)
                dispatch('getDataList',{current:1,name:reqParams.name, start:reqParams.name,end:reqParams.name}) 
                return true
            } else {
                commit("CLEAR_FILE_LIST_DATA")
                commit("UPDATE_TABLE_DATA_CACHE")
                Message.error(currentDirData.desc || "文件列表查询失败")
            }
        },
        async getDataList( {
            dispatch,
            commit,
            state
        }: { dispatch: any; commit: Commit; state: PublicStoreState },
        params: any = {}){
            let dataList: IFileItem[]=[]
            let reqParams = {
                id: state.currentDirId,
                current: params.current||state.dataCurrent,
                name: state.queryForm.fileName,
                size: params.size || 100,
                start:
          state.queryForm.createTime && state.queryForm.createTime.length
              ? state.queryForm.createTime[0]
              : null,
                end:
          state.queryForm.createTime && state.queryForm.createTime.length
              ? state.queryForm.createTime[1]
              : null,
            }
            commit('SET_DATA_CURRENT',reqParams.current)
            const res = await getFileListByNameAndTime(reqParams)
    
            if (res && res.code === 0 && res.data) {
                if (reqParams.current === 1) {
                    dataList = res.data as IFileItem[]
                } else {
                    dataList = [...state.dataList, ...(res.data as IFileItem[])]
                }
                if (dataList.length >= +res.total) {
                    commit('SET_DISABLE_GET_DATA_LIST',true)
                }

                reqParams.current++
                commit('SET_DATA_CURRENT',reqParams.current)
                commit('SET_DATA_LIST',dataList)
                commit('UPDATE_DATA_LIST_TYPE',!state.getDataListType) 

            } else {
                Message.error((res && res.desc) || '请求失败')
            }
        }
    },
    mutations: {
        SET_COPYMOVE_BOX(state: PublicStoreState, data: "move" | "copy") {
            state.copyMoveType = data
        },
        SET_COPYMOVE_BOX_SHOW(state: PublicStoreState, data: boolean) {
            state.showCopyMoveBox = data
        },
        SET_CURRENT_TABLE_ROW_DATA(state: PublicStoreState, data: IFileItem) {
            state.tableRowData = data
        },
        // SET_SELECTED_TABLE_DATAS(state: PublicStoreState, data: Array<IFileItem>) {
        //   state.tableSelectedDatas = data;
        // },
        SET_BREADCRUMB_DATA_ALL(state: PublicStoreState, data: BreadcrumbItem[]) {
            state.breadcrumbData = data
        },
        SET_POWERS(state: PublicStoreState, data: number[]) {
            state.powers = data
        },
        SET_PERMISSION_DIALOG_STATUS(state: PublicStoreState, data: boolean) {
            state.isShowPermssionDialog = data
        },
        SET_FILE_LIST_DATA(
            state: PublicStoreState,
            data: { id: string; data: { [key: string]: any } }
        ) {
            state.fileListdata[data.id] = data.data
        },
        CLEAR_FILE_LIST_DATA(state: PublicStoreState) {
            state.fileListdata = {}
        },
        SET_CURRENT_DIR_ID(state: PublicStoreState, data: string) {
            state.currentDirId = data
        },
        SET_CURRENT_SORT_NAMES(state: PublicStoreState, data: string) {
            state.sortNames = data
        },
        SET_CURRENT_SORT_TREND(state: PublicStoreState, data: number) {
            state.sortTrend = data
        },
        SET_LEFT_TREE_ID(state: PublicStoreState, data: string) {
            state.leftTreeId = data
        },
        SET_UPLOAD_DIR_ID(state: PublicStoreState, data: string) {
            state.uploadDirId = data
        },
        SET_NEW_DIR_NAME(state: PublicStoreState, data: string) {
            state.newDirName = data
        },
        SET_QUERY_FORM_FILENAME(state: PublicStoreState, data: string) {
            state.queryForm.fileName = data
        },
        SET_QUERY_FORM_CREATETIME(state: PublicStoreState, data: any) {
            state.queryForm.createTime = data
        },
        SET_CURRENT_PAGE(state: PublicStoreState, data: number) {
            state.currentPage = data
        },
        SET_PAGE_SIZE(state: PublicStoreState, data: number) {
            state.pageSize = data
        },
        SET_DATA_TOTAL_NUM(state: PublicStoreState, data: number) {
            state.dataTotalNum = data
        },
        SET_RIGHT_MENU_IS_SHOW(state: PublicStoreState, data: boolean) {
            state.isShowRightMenu = data
        },
        UPDATE_TABLE_DATA_CACHE(state: PublicStoreState) {
            state.showCacheData = !state.showCacheData
        },
        UPDATE_ZIP_DETAILS_DIALOG(state: PublicStoreState) {
            state.dialogZipDetailsVisible = !state.dialogZipDetailsVisible
        },
        UPDATE_FOLD_TREE(state: PublicStoreState) {
            state.updateFoldTree = !state.updateFoldTree
        },
        UPDATE_COMPRESS_LIST(state: PublicStoreState) {
            state.updateCompressList = !state.updateCompressList
        },
        UPDATE_UNZIP_LIST(state: PublicStoreState) {
            state.updateUnzipList = !state.updateUnzipList
        },
        UPDATE_DATA_LIST_TYPE(state: PublicStoreState,data: boolean) {
            state.getDataListType = data
        },
        SET_DISABLE_GET_DATA_LIST(state: PublicStoreState,data: boolean) {
            state.disableGetDataList = data
        },
        SET_DATA_LIST(state: PublicStoreState,data: IFileItem[]) {
            state.dataList = data
        },
        SET_IS_OPERATE(state: PublicStoreState, data: boolean) {            
            state.isOperate = data        
        },
        SET_DATA_CURRENT(state: PublicStoreState,data: number) {
            state.dataCurrent = data
        },
        SET_ICON_TYPE_SIZE(state: PublicStoreState,data: number) {
            state.iconTypeSize = data
        },
        // 路由更新时是否需要更新tree的子组件
        SET_IS_UPDATE_TREE(state: PublicStoreState, data: boolean) {
            state.isUpdateTree = data

        },
        SET_IS_VIEW_PERMISSION(state: PublicStoreState, data: boolean) {
            state.isViewPermission = data
        },
        SET_IS_GRANT_PERMISSION(state: PublicStoreState, data: boolean) {
            state.isGrantPermission = data
        }
    }
}
